import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function VideoProduction() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Transform Ideas into Impactful Videos with Strategic Video
                  Production
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We craft high-quality videos that captivate audiences and drive
                engagement. Our structured approach refines storytelling and
                visual presentation. This ensures that every video delivers a
                clear message and strengthens brand identity.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Story-Driven Videos"
                  subtitle1="Bring your brand’s message to life."
                  title2="Professional Quality"
                  subtitle2="Create videos that captivate and convert."
                  title3="Seamless Editing"
                  subtitle3="Customize content effortlessly."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                A Video Production Company for High-Quality Visual Storytelling
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we create video content that increases
                <Link to="/branding/">
                  {" "}
                  brand awareness
                </Link>{" "}
                and improves audience retention. Our team handles concept
                development and cinematography to produce compelling visuals. We
                make sure your videos communicate effectively and keep viewers
                engaged. Our tailored production strategy delivers professional
                videos that generate measurable impact.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/marketing (12).json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our Video Production Process"}
            invert={!dark}
            step1={"Concept Development and Pre-Production"}
            step1description={
              "We define the video’s core message and outline creative direction. Our team refines scriptwriting and storyboarding. We also plan production logistics to ensure a seamless shoot."
            }
            step2={"Cinematography and Production Execution"}
            step2description={
              "We film high-quality visuals and capture compelling footage. Our team works on lighting and framing to improve production value. We also focus on shot composition to create visually immersive content."
            }
            step3={"Post-Production Editing and Motion Graphics"}
            step3description={
              "We edit video sequences and refine transitions. Our team improves pacing and integrates visual effects. We also incorporate graphics to strengthen brand identity."
            }
            step4={"Sound Design and Voiceover Optimization"}
            step4description={
              "We adjust audio levels and remove background noise. Our team refines voiceovers and synchronizes music. We also optimize sound effects to improve storytelling impact."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our Video Production Services"}
            title1={"Stronger Brand Presence"}
            subtitle1={
              "We produce professional videos that improve credibility. A well-structured video strategy increases audience connection."
            }
            title2={"Higher Viewer Retention"}
            subtitle2={
              "We refine video structure and improve storytelling. Engaging visuals keep viewers interested and encourage action."
            }
            title3={"Strategic Content Optimization"}
            subtitle3={
              "We tailor video content for targeted platforms. Customized formatting improves performance across multiple channels."
            }
            title4={"Improved Production Quality"}
            subtitle4={
              "We refine cinematography and optimize post-production. High-quality visuals create a lasting impact."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={
              <h2>Video Production That Drives Engagement and Conversions</h2>
            }
            subtitle="At Riches Media Digital, we develop high-performing videos that communicate brand stories with clarity. Our structured production process refines creative execution and strengthens messaging. We work on delivering visually compelling content that improves engagement and increases conversion rates. Our video production strategy guarantees that every frame contributes to a powerful narrative."
            image={
              <img
                alt={"Video Production Companies"}
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/tab1.png")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Video Production Services Will You Get"}
            invert={!dark}
            title1={"Creative Concept Development"}
            title2={"High-Quality Cinematography"}
            title3={"Professional Post-Production Editing"}
            title4={"Strategic Platform Optimization"}
            title5={"Compelling Storytelling Execution"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is video production?"
            a1="Video production creates professional video content for marketing and brand storytelling. It involves concept development and filming. It further encircles editing and post-production refinements to improve quality."
            q2="Why is video production important for my business?"
            a2="Video content improves <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a> and strengthens brand identity. A professionally produced video communicates messages effectively and increases viewer retention. Businesses that invest in video production gain higher visibility and improved marketing results."
            q3="How long does video production take?"
            a3="Production timelines depend on video length and complexity. Most projects take four to eight weeks, from pre-production planning to final edits. Larger productions require more time for post-production refinements and quality control."
            q4="What types of videos do you produce?"
            a4="We create marketing and corporate videos. We also produce product explainers and branded content for social media."
            q5="How do you assure video quality?"
            a5="We use professional equipment and advanced editing techniques to maintain high production value. Our team prioritizes cinematography quality and post-production refinements. We also optimize video formats based on platform requirements."
            q6="How do you measure video performance?"
            a6="Video success is measured through viewer engagement and retention rates. We track watch time and conversion metrics to refine future video strategies. Performance insights help improve content impact and audience reach."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
